import { FC } from 'react';

import Col from './Col';
import Row from './Row';

const Grid: FC = () => null;

export default Object.assign(Grid, { Row, Col });
